import Values from 'values.js';

type Tints = {
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
};
type Shades = {
    1100: string;
    1200: string;
    1300: string;
    1400: string;
    1500: string;
    1600: string;
    1700: string;
    1800: string;
    1900: string;
};

const generateTints = (color, weight = 10): Tints =>
    new Values(color).tints(weight).reduce((acc, tint, index) => {
        const TINT_STARTER_LEVEL = 900;
        const WHITE_LEVEL = 0;
        const level = TINT_STARTER_LEVEL - index * 100;
        const isWhiteLevel = level === WHITE_LEVEL;
        return {
            ...acc,
            ...(!isWhiteLevel && { [level]: tint.hexString().toUpperCase() }),
        };
    }, {} as Tints);

const generateShades = (color, weight = 10): Shades =>
    new Values(color).shades(weight).reduce((acc, shade, index) => {
        const SHADE_STARTER_LEVEL = 1100;
        const BLACK_LEVEL = 2000;
        const level =
            index === 0
                ? SHADE_STARTER_LEVEL
                : SHADE_STARTER_LEVEL + index * 100;
        const isBlackLevel = level === BLACK_LEVEL;

        return {
            ...acc,
            ...(!isBlackLevel && { [level]: shade.hexString().toUpperCase() }),
        };
    }, {} as Shades);

export const generateColorScheme = (
    color: string,
    weight?: number
): {
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
    1000: string;
    1100: string;
    1200: string;
    1300: string;
    1400: string;
    1500: string;
    1600: string;
    1700: string;
    1800: string;
    1900: string;
    main: string;
} => ({
    1000: color,
    main: color,
    ...generateTints(color, weight),
    ...generateShades(color, weight),
});
